import { format } from "date-fns-tz"

export var adb_model = {
    count: 0,
    adbLogs: [{
        date: format(new Date(), "yyyy-MM-dd"),
        tag: "",
        message: ""
    }]
}

export var mdb_model = {
    count: 0,
    mdbLogs: [{
        date: format(new Date(), "yyyy-MM-dd"),
        direction: 0,
        command: ""
    }]
}

export var monitoring_last_record_model = {
    date: format(new Date(), "yyyy-MM-dd"),
    lastSale: format(new Date(), "yyyy-MM-dd"),
    configurationUpdated: format(new Date(), "yyyy-MM-dd"),
    model: "",
    submodel: "",
    batteryPercent: "0%",
    libraryVersion: ""
}
export var monitoring_model = {
    count: 0,
    monitorings: [{
        date: format(new Date(), "yyyy-MM-dd"),
        lastSale: format(new Date(), "yyyy-MM-dd"),
        configurationUpdated: format(new Date(), "yyyy-MM-dd"),
        model: "",
        submodel: "",
        batteryPercent: "0%",
        libraryVersion: ""
    }]
}
